export const ROUTE_DASHBOARD = "/tnpsc/dashboard";
export const ROUTE_CHAT = "/tnpsc/chat";
export const ROUTE_QUIZ = "/tnpsc/quiz";
export const ROUTE_LOGIN = "/";
export const ROUTE_SIGN_UP = "/tnpsc/sign-up";
export const ROUTE_AI_GENERATE = "/tnpsc/ai-generate";
export const ROUTE_DESCRIPTIVE = "/tnpsc/descriptive";
export const ROUTE_AI_ANALYSIS = "/tnpsc/analysis";
export const ROUTE_PROFILE = "/tnpsc/profile";
export const ROUTE_PAYMENT_SUCCESS = "/tnpsc/payment-success";
// Admin App Routes (root level routes for admin app)
export const ROUTE_STUDENT_MANAGEMENT = "/tnpsc/student-management";
export const ROUTE_SCHOOL_MANAGEMENT = "/tnpsc/school-managament";
export const ROUTE_LEARNING_ASSETS = "/tnpsc/learning-assets";
export const ROUTE_MOCK_TEST = "/tnpsc/mock-test";
export const routeToMCQ = (subject) =>
  `/tnpsc/${ROUTE_QUIZ}?subject=${subject}`;
export const ROUTE_COMPETITIVE_EXAM = "/tnpsc/competitive-exam";
export const routeEvalutionToQuiz = (subject, chapter) =>
  `${ROUTE_QUIZ}?subject=${subject}&chapter=${chapter}`;
export const routeEvalutionTnspscToQuiz = (
  medium,
  part,
  unit,
  chapter,
  lesson,
) =>
  `${ROUTE_QUIZ}?medium=${medium}&part=${part}&unit=${unit}&chapter=${chapter}&lesson=${lesson}`;
